import { gql } from "@apollo/client";

export const GET_TOP_SALE_TICKETS = gql`
  query getTopSalesTickets($month: String!, $year: String!, $userId: uuid!, $userRole: String!) {
    getTopSales(args: { month: $month, year: $year, user_id: $userId, user_role: $userRole }) {
      leagueName
      totalCounts
    }
  }
`;

// Legacy affiliate flow (matches old web behavior)
export const GET_TOP_SALE_TICKETS_LEGACY = gql`
  query getTopSalesTickets($month: String!, $year: String!) {
    getTopSalesTickets(topSalesInput: {month:$month,year:$year}) {
      leagueName
      totalCounts
    }
  }
`;

export const GET_REVENUE_SUPER_USER_DASHBOARD = gql`
  query RevenuesSuperUserDashboard($startYear: Int!, $endYear: Int!, $startMonth: String!, $endMonth: String!, $userId: uuid!) {
    getRevenueForSuperUser(args: { endMonth: $endMonth, endYear: $endYear, startMonth: $startMonth, startYear: $startYear, user_id: $userId }) {
      monthsName
      revenue
      totalTickets
    }
    getRevenueForSuperUserAggregate(args: { endMonth: $endMonth, endYear: $endYear, startMonth: $startMonth, startYear: $startYear, user_id: $userId }) {
      overAllTickets
      overAllSales
      avgListPrice
      quickasystFee
    }
  }
`;

export const GET_PENDING_TICKETS = gql`
  query getPendingTickets($limit: Int, $offset: Int, $userId: uuid!, $userRole: String!) {
    getPendingActiveTicketsByLeague(args: { user_id: $userId, user_role: $userRole }, limit: $limit, offset: $offset, order_by: { activeTickets: desc }) {
      leagueName
      activeTickets
    }
    getPendingActiveTicketsCountAndPayout(args: { user_id: $userId, user_role: $userRole }) {
      totalCount
      potentialPayout
    }
  }
`;

// Legacy affiliate flow (matches old web behavior)
export const GET_PENDING_TICKETS_LEGACY = gql`
  query getPendingTicketsDashboard {
    getPendingTicketsDashboard {
      getPendingActiveTicketsByLeague {
        activeTickets
        leagueName
      }
      getPendingActiveTicketsCountAndPayout {
        potentialPayout
        totalCount
      }
    }
  }
`;

export const GET_REVENUE_ADMIN = gql`
query RevenuesDashboard ($startYear: Int!, $endYear: Int!, $startMonth: String!, $endMonth: String!) {
  getRevenueForAdmin(args: {endMonth:$endMonth,endYear:$endYear,startMonth:$startMonth,startYear:$startYear}) {
    monthsName
    revenue
    totalTickets
  }
  getRevenueForAdminAggregate(args: {endMonth:$endMonth,endYear:$endYear,startMonth:$startMonth,startYear:$startYear}) {
    overAllTickets
    overAllSales
    quickasystFee
    avgListPrice
  }
}
`;


export const GET_USERS_LIST = gql`
  query GetDashboardUsers($searchText: String = "%%") {
    user(
      limit: 10
      where: {
        _or: [
          { u_full_name: { _ilike: $searchText } }
          { u_email_id: { _ilike: $searchText } }
        ]
      }
      order_by: { u_full_name: asc }
    ) {
      u_id
      u_full_name
      u_email_id
      u_pricing_mode
    }
  }
`;

export const GET_MARKETPLACES = gql`
  query GetMarketplaces {
    marketplaces(order_by: { name: asc }) {
      id
      name
      vl_fee_percentage
      active
      qa_nets
    }
  }
`;

export const GET_TICKET_STATUS_COUNTS = gql`
  query GetTicketStatusCounts {
    toBeVerifiedCount: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}}
    ) { aggregate { count } }

    verifiedCount: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}}
    ) { aggregate { count } }
      

    listedCount: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true} , tp_status: {_eq: "List"}}
    ) { aggregate { count } }

    soldCount: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}}
    ) { aggregate { count } }

    settledCount: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}}
    ) { aggregate { count } }

    delistedCount: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}}
    ) { aggregate { count } }

    unsoldCount: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}}
    ) { aggregate { count } }
  }
`;

// Date-filtered variant — used only when Sell Dashboard date range is active.
export const GET_TICKET_STATUS_COUNTS_DATED = gql`
  query GetTicketStatusCountsDated($startdate: date, $enddate: date) {
    toBeVerifiedCount: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}}
    ) { aggregate { count } }

    verifiedCount: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}}
    ) { aggregate { count } }

    listedCount: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true} , tp_status: {_eq: "List"}}
    ) { aggregate { count } }

    soldCount: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}}
    ) { aggregate { count } }

    settledCount: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}}
    ) { aggregate { count } }

    delistedCount: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}}
    ) { aggregate { count } }

    unsoldCount: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}}
    ) { aggregate { count } }
  }
`;

// Per-user ticket status counts (direct ticket_placement_aggregate filtered by ticket.u_id)
export const GET_TICKET_STATUS_COUNTS_BY_USER = gql`
  query GetTicketStatusCountsByUser($userId: uuid!) {
    toBeVerifiedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: ToBeVerified}, tp_is_published: {_eq: false}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    verifiedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: Verified}, tp_is_published: {_eq: false}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    listedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: List}, tp_is_published: {_eq: true}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    soldCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: Sold}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    settledCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: Sold}, tp_payment_status: {_eq: Success}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    delistedCount: ticket_placement_aggregate(where: {
      tp_status: {_in: [Delist, DelistInProgress, DelistRequested, Return]}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    unsoldCount: ticket_placement_aggregate(where: {
      tp_status: {_in: [Unsold]}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { count } }

    pendingPotential: ticket_placement_aggregate(where: {
      tp_status: {_in: [ToBeVerified, Verified, List]}
      user: {u_id: {_eq: $userId}}
    }) { aggregate { sum { tp_list_price } count } }
  }
`;

// Per-sales-rep ticket status counts (scoped by assigned users)
export const GET_TICKET_STATUS_COUNTS_BY_SALES_REP = gql`
  query GetTicketStatusCountsBySalesRep($salesRepId: uuid!) {
    toBeVerifiedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: ToBeVerified}, tp_is_published: {_eq: false}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }

    verifiedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: Verified}, tp_is_published: {_eq: false}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }

    listedCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: List}, tp_is_published: {_eq: true}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }

    soldCount: ticket_placement_aggregate(where: {
      tp_status: {_eq: Sold}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }

    delistedCount: ticket_placement_aggregate(where: {
      tp_status: {_in: [Delist, DelistInProgress, DelistRequested, Return]}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }

    unsoldCount: ticket_placement_aggregate(where: {
      tp_status: {_in: [Unsold]}
      user: {u_sales_reps_id: {_eq: $salesRepId}}
    }) { aggregate { count } }
  }
`;

// Per-sales-rep ticket status counts using explicit managed user ids.
export const GET_TICKET_STATUS_COUNTS_BY_USER_IDS = gql`
  query GetTicketStatusCountsByUserIds($userIds: [uuid!]!) {
    toBeVerifiedCount: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}, u_id: {_in: $userIds}}
    ) { aggregate { count } }

    verifiedCount: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}, u_id: {_in: $userIds}}
    ) { aggregate { count } }

    listedCount: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_id: {_in: $userIds}}
    ) { aggregate { count } }

    soldCount: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_id: {_in: $userIds}}
    ) { aggregate { count } }

    delistedCount: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested"]}, u_id: {_in: $userIds}}
    ) { aggregate { count } }

    unsoldCount: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}, u_id: {_in: $userIds}}
    ) { aggregate { count } }
  }
`;

// Per-league sold revenue + list timing — both from filterlisttickets
export const GET_LEAGUE_AND_TIMING_DATA = gql`
  query GetLeagueAndTimingData {
    soldByLeague: filterlisttickets(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}}
    ) {
      e_date
      l_name
      tp_sold_amount
      tp_quick_cut_amount
    }
    listedForTiming: filterlisttickets(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_in: ["List", "Sold"]}}
    ) {
      tp_created_at
      e_date
    }
  }
`;

// Per-league sold revenue + list timing filtered by user
export const GET_LEAGUE_AND_TIMING_DATA_BY_USER = gql`
  query GetLeagueAndTimingDataByUser($userId: uuid!) {
    soldByLeague: filterlisttickets(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_id: {_eq: $userId}}
    ) {
      e_date
      l_name
      tp_sold_amount
      tp_quick_cut_amount
    }
    listedForTiming: filterlisttickets(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_in: ["List", "Sold"]}, u_id: {_eq: $userId}}
    ) {
      tp_created_at
      e_date
    }
  }
`;


// Per-marketplace sold data — use tp_marketplace_name (not tp_execution_type)
export const GET_SOLD_TICKETS_BY_MARKETPLACE = gql`
  query GetSoldTicketsByMarketplace {
    soldByMarketplace: getmanageticketwithvlids(
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}}
    ) {
      e_date
      tp_marketplace_name
      tp_sold_amount
      tp_quick_cut_amount
    }
  }
`;

// Aggregate sold revenue by sale date (tp_sold_at) — used by Dashboard financial metrics
export const GET_SOLD_REVENUE_BY_SOLD_DATE = gql`
  query GetSoldRevenueBySoldDate($startdate: timestamptz!, $enddate: timestamptz!) {
    soldAgg: ticket_placement_aggregate(
      where: {
        tp_status: {_eq: Sold},
        tp_is_support_vanderbilt_nil_fund: {_eq: false},
        tp_sold_at: {_gte: $startdate, _lte: $enddate}
      }
    ) {
      aggregate {
        sum {
          tp_logitix_amount
          tp_quick_cut_amount
          tp_sold_amount
        }
        count
      }
    }
  }
`;

export const GET_SOLD_TICKET_PLACEMENTS_BY_SOLD_DATE = gql`
  query GetSoldTicketPlacementsBySoldDate($startdate: timestamptz!, $enddate: timestamptz!) {
    ticket_placement(
      where: {
        tp_status: {_eq: Sold},
        tp_is_support_vanderbilt_nil_fund: {_eq: false},
        tp_sold_at: {_gte: $startdate, _lte: $enddate}
      }
    ) {
      tp_logitix_amount
      tp_sold_amount
      tp_quick_cut_amount
    }
  }
`;

// Per-client-type league sold revenue + list timing (uses ticket_placement with nested user/league join)
export const GET_LEAGUE_AND_TIMING_DATA_BY_CLIENT_TYPE = gql`
  query GetLeagueAndTimingDataByClientType($clientType: String!) {
    soldByLeagueRaw: ticket_placement(where: {
      tp_is_published: {_eq: true}
      tp_status: {_eq: Sold}
      user: { u_pricing_mode: {_eq: $clientType} }
    }) {
      ticket {
        event {
          e_date
          event_categories {
            league_category {
              league { l_name }
            }
          }
        }
      }
      tp_sold_amount
      tp_quick_cut_amount
    }
    listedForTimingRaw: ticket_placement(where: {
      tp_is_published: {_eq: true}
      tp_status: {_in: [List, Sold]}
      user: { u_pricing_mode: {_eq: $clientType} }
    }) {
      tp_created_at
      ticket { event { e_date } }
    }
  }
`;



// Sold revenue, pending potential, and ticket counts filtered by u_pricing_mode
// export const GET_REVENUE_BY_PRICING_MODE = gql`
//   query GetRevenueByPricingMode {
//     selfPricing: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Sold}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) {
//       aggregate { sum { tp_sold_amount tp_quick_cut_amount } count }
//     }
//     concierge: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Sold}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) {
//       aggregate { sum { tp_sold_amount tp_quick_cut_amount } count }
//     }

//     # ── Pending potential (tp_list_price sum for all non-sold tickets) ───────
//     allPendingPotential: ticket_placement_aggregate(where: {
//       tp_status: {_in: [ToBeVerified, Verified, List]}
//     }) {
//       aggregate { sum { tp_list_price } count }
//     }
//     selfPricingPending: ticket_placement_aggregate(where: {
//       tp_status: {_in: [ToBeVerified, Verified, List]}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) {
//       aggregate { sum { tp_list_price } count }
//     }
//     conciergePending: ticket_placement_aggregate(where: {
//       tp_status: {_in: [ToBeVerified, Verified, List]}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) {
//       aggregate { sum { tp_list_price } count }
//     }

//     # ── Ticket status counts filtered by client type ─────────────────────────
//     spToBeVerified: ticket_placement_aggregate(where: {
//       tp_status: {_eq: ToBeVerified} tp_is_published: {_eq: false}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     spVerified: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Verified} tp_is_published: {_eq: false}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     spListed: ticket_placement_aggregate(where: {
//       tp_status: {_eq: List} tp_is_published: {_eq: true}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     spSoldTickets: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Sold}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     spDelisted: ticket_placement_aggregate(where: {
//       tp_status: {_in: [Return, Delist, DelistInProgress, DelistRequested]}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     spUnsold: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Unsold}
//       user: { u_pricing_mode: {_eq: "self-pricing"} }
//     }) { aggregate { count } }
//     cxToBeVerified: ticket_placement_aggregate(where: {
//       tp_status: {_eq: ToBeVerified} tp_is_published: {_eq: false}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }
//     cxVerified: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Verified} tp_is_published: {_eq: false}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }
//     cxListed: ticket_placement_aggregate(where: {
//       tp_status: {_eq: List} tp_is_published: {_eq: true}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }
//     cxSoldTickets: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Sold}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }
//     cxDelisted: ticket_placement_aggregate(where: {
//       tp_status: {_in: [Return, Delist, DelistInProgress, DelistRequested]}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }
//     cxUnsold: ticket_placement_aggregate(where: {
//       tp_status: {_eq: Unsold}
//       user: { u_pricing_mode: {_eq: "concierge"} }
//     }) { aggregate { count } }

//     # ── User counts by client type ────────────────────────────────────────────
//     selfPricingUsers: user_aggregate(where: {
//       u_pricing_mode: {_eq: "self-pricing"}
//       u_is_active: {_eq: true}
//       u_delete_requested: {_eq: false}
//     }) { aggregate { count } }
//     conciergeUsers: user_aggregate(where: {
//       u_pricing_mode: {_eq: "concierge"}
//       u_is_active: {_eq: true}
//       u_delete_requested: {_eq: false}
//     }) { aggregate { count } }
//     untaggedUsers: user_aggregate(where: {
//       u_pricing_mode: {_is_null: true}
//       u_is_active: {_eq: true}
//       u_delete_requested: {_eq: false}
//     }) { aggregate { count } }
//   }
// `;
export const GET_REVENUE_BY_PRICING_MODE = gql`
  query GetRevenueByPricingMode {
    # ── Sold revenue by pricing mode (via filterlisttickets view) ──
    selfPricing: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }

    concierge: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }

    # ── All pending potential (manage=ToBeVerified+Verified, list=List) ──
    allPendingManage: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}}
    ) { aggregate { sum { tp_list_price } count } }
    allPendingList: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}}
    ) { aggregate { sum { tp_list_price } count } }

    # ── Self-pricing pending ──
    selfPricingPendingManage: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_list_price } count } }
    selfPricingPendingList: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_list_price } count } }

    # ── Concierge pending ──
    conciergePendingManage: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_list_price } count } }
    conciergePendingList: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_list_price } count } }

    # ── SP ticket status counts ──
    spToBeVerified: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spVerified: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spListed: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spSoldTickets: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spSettled: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spDelisted: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spUnsold: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }

    # ── CX ticket status counts ──
    cxToBeVerified: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxVerified: filtermanagetickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxListed: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxSoldTickets: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxSettled: filterlisttickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxDelisted: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxUnsold: filterreturntickets_aggregate(
      args: {enddate: null, leagueid: null, startdate: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
  }
`;

// Date-filtered variant — used only when Sell Dashboard date range is active.
export const GET_REVENUE_BY_PRICING_MODE_DATED = gql`
  query GetRevenueByPricingModeDated($startdate: date, $enddate: date) {
    selfPricing: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }

    concierge: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }

    allPendingManage: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}}
    ) { aggregate { sum { tp_list_price } count } }
    allPendingList: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}}
    ) { aggregate { sum { tp_list_price } count } }

    selfPricingPendingManage: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_list_price } count } }
    selfPricingPendingList: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_list_price } count } }

    conciergePendingManage: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: null, day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_in: ["ToBeVerified", "Verified"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_list_price } count } }
    conciergePendingList: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_list_price } count } }

    spToBeVerified: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spVerified: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spListed: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spSoldTickets: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spSettled: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spDelisted: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }
    spUnsold: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { count } }

    cxToBeVerified: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "ToBeVerified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "ToBeVerified"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxVerified: filtermanagetickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticket_status: "Verified", day: null, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_is_published: {_eq: false}, tp_status: {_eq: "Verified"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxListed: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "List"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxSoldTickets: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxSettled: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, tp_payment_status: {_eq: "Success"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxDelisted: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Delist", "DelistInProgress", "DelistRequested", "Return"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
    cxUnsold: filterreturntickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null}
      where: {tp_status: {_in: ["Unsold"]}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { count } }
  }
`;

// Separate query for user counts by pricing mode (user_aggregate may have different permissions)
export const GET_USER_COUNTS_BY_TYPE = gql`
  query GetUserCountsByType {
    selfPricingUsers: user_aggregate(where: {
      u_pricing_mode: {_eq: "self-pricing"}
    }) { aggregate { count } }

    conciergeUsers: user_aggregate(where: {
      u_pricing_mode: {_eq: "concierge"}
    }) { aggregate { count } }

    untaggedUsers: user_aggregate(where: {
      u_pricing_mode: {_is_null: true}
    }) { aggregate { count } }
  }
`;

// Signup funnel — aggregate user counts at each onboarding step, filtered by period
export const GET_SIGNUP_FUNNEL_DATA = gql`
  query GetSignupFunnelData($cutoffDate: timestamptz!) {
    started: user_aggregate(where: {
      u_created_at: {_gte: $cutoffDate}
      u_is_active: {_eq: true}
      u_delete_requested: {_eq: false}
    }) { aggregate { count } }

    submittedInfo: user_aggregate(where: {
      u_created_at: {_gte: $cutoffDate}
      u_is_active: {_eq: true}
      u_delete_requested: {_eq: false}
      u_first_name: {_neq: ""}
    }) { aggregate { count } }

    selectedAccountType: user_aggregate(where: {
      u_created_at: {_gte: $cutoffDate}
      u_is_active: {_eq: true}
      u_delete_requested: {_eq: false}
      u_seller_type: {_is_null: false}
    }) { aggregate { count } }

    selectedPricing: user_aggregate(where: {
      u_created_at: {_gte: $cutoffDate}
      u_is_active: {_eq: true}
      u_delete_requested: {_eq: false}
      u_pricing_mode: {_is_null: false}
    }) { aggregate { count } }

    completedSignup: user_aggregate(where: {
      u_created_at: {_gte: $cutoffDate}
      u_is_active: {_eq: true}
      u_delete_requested: {_eq: false}
      u_pricing_mode: {_is_null: false}
      u_seller_type: {_is_null: false}
    }) { aggregate { count } }
  }
`;



export const GET_USER_REVENUE_ANALYTICS = gql`
  query GetUserRevenueAnalytics($userId: String!) {
    getUserRevenueAnalytics(userId: $userId) {
      totalRevenue
      qaProfit
      totalTickets
      avgPrice
      vlFee
      userPayout
    }
  }
`;



// For user-specific
export const GET_SOLD_TICKETS_BY_MARKETPLACE_BY_USER = gql`
  query GetSoldTicketsByMarketplaceByUser($userId: uuid!) {
    soldByMarketplace: getmanageticketwithvlids(
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_id: {_eq: $userId}}
    ) {
      e_date
      tp_marketplace_name
      tp_sold_amount
      tp_quick_cut_amount
      tp_created_at
      u_id
    }
  }
`;

// For client-type (self-pricing / concierge)
export const GET_SOLD_TICKETS_BY_MARKETPLACE_BY_CLIENT_TYPE = gql`
  query GetSoldTicketsByMarketplaceByClientType($clientType: String!) {
    soldByMarketplace: getmanageticketwithvlids(
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, ticket_user: {u_pricing_mode: {_eq: $clientType}}}
    ) {
      e_date
      tp_marketplace_name
      tp_sold_amount
      tp_quick_cut_amount
      tp_created_at
      u_id
    }
  }
`;


export const GET_REVENUE_BY_SALE_DATE = gql`
  query GetRevenueBySaleDate($startdate: date, $enddate: date) {
    soldBySaleDate: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}}
    ) {
      aggregate { 
        sum { tp_sold_amount tp_quick_cut_amount } 
        count 
      }
    }
  }
`;

/**
 * Get revenue by pricing mode filtered by sale date (tp_sold_at)
 */
export const GET_REVENUE_BY_PRICING_MODE_SALE_DATE = gql`
  query GetRevenueByPricingModeSaleDate($startdate: date, $enddate: date) {
    selfPricing: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "self-pricing"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }

    concierge: filterlisttickets_aggregate(
      args: {enddate: $enddate, leagueid: null, startdate: $startdate, ticketid: null, tpid: null, array_tpid: null, payment_status: null, ticket_status: null}
      where: {tp_is_published: {_eq: true}, tp_status: {_eq: "Sold"}, u_pricing_mode: {_eq: "concierge"}}
    ) { aggregate { sum { tp_sold_amount tp_quick_cut_amount } count } }
  }
`;